export function parseApiError(
  err,
  fallbackMessage = "An error occured processing your current request!",
) {
  let message = fallbackMessage;
  console.log(err);
  if (typeof err === "string") {
    message = err;
  } else if (err?.data) {
    const data = err.data;
    if (Array.isArray(data?.ValidationErrors)) {
      message = data.ValidationErrors?.map((error) => error.errorMessage).join(
        ", ",
      );
    } else if (data?.detail) {
      message = data?.detail;
    } else {
      message = data;
    }
  } else if (err?.request) {
    // Request was made but no response received
    message =
      "No response from server. Please check your internet connection or contact support if the issue persist.!";
  } else if (err?.message) {
    message = err.message;
  }
  return message;
}

//  if (err?.response) {
//    const data = err.response.data;

//    if (typeof data === "string") {
//      message = data;
//    } else if (data?.message) {
//      message = data.message;
//    } else if (Array.isArray(data?.errors)) {
//      message = data.errors.join(", ");
//    } else if (typeof data?.errors === "object") {
//      // message = Object.values(data.errors).flat().join(", ") || message;
//      message =
//        Object.entries(data.errors)
//          .map((item) => `${item[0]}: ${item[1]}`)
//          .join(", ") || message;
//    }
//  } else if (err?.request) {
//    // Request was made but no response received
//    message =
//      "No response from server. Please check your internet connection or contact support if the issue persist.!";
//  } else if (err?.message) {
//    message = err.message;
//  }

// {
//     "title": "UserNotFoundException",
//     "status": 404,
//     "detail": "Entity \"User\" (pauldev1) was not found.",
//     "instance": "/identity/sign-in",
//     "traceId": "80000388-0001-e900-b63f-84710c7967bb"
// }
